import { render, staticRenderFns } from "./HandleColumnModal.vue?vue&type=template&id=68c34d5e&scoped=true&"
import script from "./HandleColumnModal.vue?vue&type=script&lang=ts&"
export * from "./HandleColumnModal.vue?vue&type=script&lang=ts&"
import style0 from "./HandleColumnModal.vue?vue&type=style&index=0&id=68c34d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c34d5e",
  null
  
)

export default component.exports